import type { ProvenanceData } from 'generated/graphql';

function hasRealProvenanceData(data: Nullable<ProvenanceData>): boolean {
  if (data == null) {
    return false;
  }

  // Dynamically check all fields except __typename
  return Object.entries(data).some(([key, value]) => {
    return key !== '__typename' && value !== null && value !== undefined;
  });
}

export function mergeProvenanceData(
  existing: Nullable<ProvenanceData>,
  incoming: Nullable<ProvenanceData>
): Nullable<ProvenanceData> {
  // Never allow null/undefined to overwrite existing data
  if (incoming == null) {
    return existing ?? incoming;
  }

  // If existing has real data and incoming only has nulls, keep existing
  const existingHasRealData = hasRealProvenanceData(existing);

  // Dynamically check if incoming only has nulls (excluding __typename)
  const incomingOnlyHasNulls = Object.entries(incoming).every(([key, value]) => {
    return key === '__typename' || value === null;
  });

  if (existingHasRealData && incomingOnlyHasNulls) {
    return existing;
  }

  // Otherwise use incoming (it might have real data)
  return incoming;
}
